import React, { useEffect, useState } from "react";
import { ChevronDown } from "react-feather";
import { formatNumberWithCommas } from "../constants/commonFunction";
import { useParams } from 'react-router-dom'
import { Col, Container, Row } from "react-bootstrap";
import ProfileService from "../services/Profile";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import { useSelector } from "react-redux";
import NoData from "../component/NoData";

function PointsEarnedDetails() {
  const tokens =  useSelector(
    state => state.userTypeSlice.token,
  );
  const { month, year} = useParams();
  const [list, setList] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [limit, setlimit] = useState(50);
  const [hasMore, setHasMore] = useState(true);
  const [loadingst, setLoadingst] = useState(true);
  const [isSelectedItem, setIsSelectedItem] = useState({id: "", title: ""})
  const [token, setToken] = useState("");

  const month_name=['January','February','March','April','May','June','July','August','September','October','November','December',]
  const monthNumber=(month_name.indexOf(month) + 1);

  useEffect(() => {
      // const tok = localStorage.getItem("access-token");
      setToken(tokens.access);
      // if (pageNo == 1 && !loadingst) {
        getPoints(tokens.access, monthNumber, year);
      // }

  }, [pageNo, tokens])

  function handleShowMore() {}
  function handleAccordionOpen(id) {
    if(id == isSelectedItem){
      setIsSelectedItem("")
      return;
    }
    setIsSelectedItem(id)
  }

  async function getPoints(tok, month_number, year_number) {
    const trans_desc = ''

    ProfileService.getPointsEarnedDetailsView(
      tok,
      month_number,
      year_number,
      'C',
      trans_desc,
      limit,
      pageNo,
    )
      .then(res => {
        if (res.success === true) {
          const trnasc_list = res.response.pointDetails;
          if (trnasc_list.length == 0) {
            setHasMore(false);
          } else {
            // if (pageNo == 1) {
              setList(p => [...p, ...trnasc_list]);
              // setList([]);
              // setcredit_list([]);
              // setdebit_list([]);
              // settds_list([]);
            // }

   
          }
          setLoadingst(false);
        } else {
          setList([]);
        }

      })
      .catch(err => {
        setLoadingst(false);
      });
  };

  useEffect(() => {

  }, [])

  return (
    <Container>
       <Row className="my-4">
        {list.length === 0 && !loadingst && <NoData />}
      {list.map((item, index) => {
        const dateTime = new Date(item.created_at);
        const formattedDateTime = dateTime.toLocaleString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          hour12: true,
        });
        return (
          <Col xs={12} key={index}>
            <div className="pointsSpentBlock ad-acc">
              {/* <div className='pointsSpentBlock'> */}

              {/* <div className='pointsSpentTitle'> */}
              <div className="pointsSpentAmount col text-right">
                <p>{item.transaction_desc}</p>
                <span>{formattedDateTime}</span>
              </div>
              <div className="pointsSpentAmountNo">
                <p className="greenTxt mb-0">
                  {" "}
                  + {formatNumberWithCommas(item.reward_points)}
                </p>
              </div>
              <div
                className="pointsSpentAmountViewMoreBtn"
                onClick={() => {
                  handleAccordionOpen(item.id);
                }}
              >
                <ChevronDown />
              </div>
            </div>
            {isSelectedItem == item.id && (
              //  <div className='pointsSpentAmountViewMoreWrap'>
              <div className="pointsSpentAmountViewMoreWrap bg-white">
                <table className="table table-bordered">
                  <tr>
                    <th colSpan={3}>Points were credited using</th>
                  </tr>
                  <tr>
                    <td>Sale Id</td>

                    <td>Available Points</td>
                  </tr>

                  <tr>
                    <td>{item.sale_id}</td>
                    <td>
                      <div className="greenTxt">
                        + {formatNumberWithCommas(item.reward_points)}
                      </div>
                    </td>
                    {/* <td>{pointRedemptionData}</td> */}
                  </tr>
                </table>
              </div>
            )}
          </Col>
        );
      })}
      {/* {( */}
      {list.length > 0 && <Row className="justify-content-center my-4">
        <Col xs={12} lg={3}>
          <PrimaryGradientButton
            onClick={()=>{setPageNo(p => p+1)}}
            buttonText="Show More"
            disabled={!hasMore}
          />
        </Col>
      </Row>}
    </Row>
    </Container>
   
  );
}

export default PointsEarnedDetails;
